<template>
  <layout-auth
    message="Need a New Password?"
    sub-message="Enter your email below and we'll send you a reset email."
  >
    <form-field-input
      v-model="forgotPasswordForm.email"
      :validation-errors="validationErrors.email"
      size=""
      v-autofocus
    ></form-field-input>

    <button-default
      class="auth_button"
      size=""
      :disabled="isRequesting"
      :loading="isRequesting"
      @click="requestPassword"
    >Get Reset Email</button-default>
  </layout-auth>
</template>

<script>
import auth from "../../api/auth";

export default {
  name: "PasswordRequest",
  metaInfo: {
    title: "Request Password"
  },
  data() {
    return {
      isRequesting: false,
      forgotPasswordForm: {
        email: null,
      },
      validationErrors: {},
    }
  },
  methods: {
    requestPassword() {
      this.isRequesting = true;
      auth.forgotPassword(this.forgotPasswordForm).finally(() => {
        this.isRequesting = false;
        this.$buefy.snackbar.open({message: 'Check you email for the reset link'});
      });
    }
  }
}
</script>
